<template>
  <VueCtkDateTimePicker :range="true" v-model="value"
    id="setDateRange"
    class="getDate"
    :only-date="true"
    :color="'var(--color-pri)'"
    :no-label="true"
    :auto-close="true"
    :locale="'zh-tw'"
    :input-size="size ? size : 'md'"
    :inline="!!inline"
    :format="'YYYY-MM-DD'"
    :formatted="'YYYY-MM-DD'"
    :label="'請選擇日期範圍'" :disabled="disabled"
    :custom-shortcuts="shortcuts"/>
</template>

<script>
export default {
  props: ['defaultValue', 'inline', 'size', 'disabled', 'shortcuts'],
  data () {
    return {
      value: null
    }
  },
  mounted () {
    this.value = this.defaultValue
  },
  watch: {
    value () {
      if (this.value !== this.defaultValue) {
        this.$emit('input', this.value)
      }
    }
  }
}
</script>

<style lang="scss">
#setDateRange-wrapper {
  width: 290px;
  &>.field {
    .field-clear-button {
      right: 40px;
    }
    &>input[type=text] {
      height: 40px;
      border: 1px solid #B9B9B9;
      font-size: 16px!important;
      letter-spacing: .1em;
    }
    &::after {
      content: '';
      display: inline-block;
      width: 20px;
      height: 20px;
      background-color: var(--color-pri);
      mask-image: url(./svg/icon/celender.svg);
      position: absolute;
      right: 10px;
    }
  }
  #setDateRange-input {
    padding-right: 66px;
    height: 45px;
    font-size: 20px!important;
    color: #676767;
  }
}
</style>
